var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("e-store-combo", {
                        attrs: {
                          id: "filters-store",
                          required: false,
                          placeholder: _vm.$t("Todos"),
                        },
                        model: {
                          value: _vm.filter.storeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "storeId", $$v)
                          },
                          expression: "filter.storeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "region",
                          type: "vue-select",
                          label: _vm.$t("Região"),
                          options: _vm.storeRegions(),
                          placeholder: _vm.$t("Todos"),
                        },
                        model: {
                          value: _vm.filter.region,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "region", $$v)
                          },
                          expression: "filter.region",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "province",
                          type: "vue-select",
                          label: _vm.$t("Estado"),
                          placeholder: _vm.$t("Todos"),
                          options: _vm.provincesWithStores(),
                        },
                        model: {
                          value: _vm.filter.province,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "province", $$v)
                          },
                          expression: "filter.province",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "city",
                          type: "text",
                          label: _vm.$t("Cidade"),
                        },
                        model: {
                          value: _vm.filter.city,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "city", $$v)
                          },
                          expression: "filter.city",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "ean",
                          type: "text",
                          label: _vm.$t("EAN"),
                        },
                        model: {
                          value: _vm.filter.ean,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "ean", $$v)
                          },
                          expression: "filter.ean",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "name",
                          type: "text",
                          label: _vm.$t("Nome"),
                        },
                        model: {
                          value: _vm.filter.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "name", $$v)
                          },
                          expression: "filter.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "period",
                          type: "date-range-picker",
                          label: _vm.$t("Período"),
                          opens: "left",
                        },
                        model: {
                          value: _vm.filter.period,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "period", $$v)
                          },
                          expression: "filter.period",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "active",
                          type: "vue-select",
                          label: _vm.$t("Status"),
                          placeholder: _vm.$t("Todos"),
                          options: _vm.activeInactiveTypes(),
                        },
                        model: {
                          value: _vm.filter.active,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "active", $$v)
                          },
                          expression: "filter.active",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "activeOnline",
                          type: "vue-select",
                          label: _vm.$t("Site?"),
                          placeholder: _vm.$t("Todos"),
                          options: _vm.yesNoTypes(),
                        },
                        model: {
                          value: _vm.filter.activeOnline,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "activeOnline", $$v)
                          },
                          expression: "filter.activeOnline",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.filterData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c("b-table", {
            ref: "product-kits-table",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("PRODUCT_KIT.NAME"),
                "male",
                _vm.queryExecuted
              ),
              fields: _vm.fields,
              items: _vm.productKits,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getData,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(active)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: { status: row.item.active },
                    }),
                  ]
                },
              },
              {
                key: "cell(activeOnline)",
                fn: function (row) {
                  return [
                    _c("e-status-badge", {
                      attrs: { status: row.item.activeOnline, type: "yesNo" },
                    }),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "is-active": row.item.active,
                        "show-update": _vm.$can("Update", "ProductKit"),
                        "show-delete": false,
                        "show-activate": _vm.$can("Activate", "ProductKit"),
                        "show-deactivate": _vm.$can("Deactivate", "ProductKit"),
                      },
                      on: {
                        update: function ($event) {
                          return _vm.onUpdateKit(row)
                        },
                        activate: function ($event) {
                          return _vm.activateDeactivateKit(row)
                        },
                        deactivate: function ($event) {
                          return _vm.activateDeactivateKit(row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            { staticClass: "pt-1" },
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "product-kit-table",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.$can("Create", "ProductKit")
        ? _c("fab", {
            attrs: { "main-tooltip": _vm.$t("Adicionar Kit de Produto") },
            on: { click: _vm.onCreateKit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }